import React from "react";
import AdditionalPackagesSection from "../AdditionalPackagesSection";
import { useCalculatorContext } from "./DetailsCalculatorProvider";

interface DetailsPageCalculatorAdditionalPackagesProps {
  pageType: string;
  calculatorTabSelected: number;
  infoPackageItems: any;
  literals: any;
  isSeoModel: boolean;
  modelNameForHeaders: string;
}

export function DetailsPageCalculatorAdditionalPackages({
  pageType,
  calculatorTabSelected,
  infoPackageItems,
  literals,
  isSeoModel,
  modelNameForHeaders
}: DetailsPageCalculatorAdditionalPackagesProps) {
  if (pageType === "auction" || calculatorTabSelected === 3) {
    return null;
  }

  return (
    <div className="mleasing-main-container bg-gray without-max-width" id="additionalServices">
      <div className="content-wrapper">
        <div className="left-wing">
          <AdditionalPackagesSection
            items={infoPackageItems}
            literals={literals}
            isSeoModel={isSeoModel}
            modelNameForHeaders={modelNameForHeaders}
          />
        </div>
      </div>
    </div>
  );
}

interface DetailsPageCalculatorAdditionalPackagesConnectedProps {
  pageType: string;
  literals: any;
  isSeoModel: boolean;
  modelNameForHeaders: string;
}

export function DetailsPageCalculatorAdditionalPackagesConnected({
  pageType,
  literals,
  isSeoModel,
  modelNameForHeaders
}: DetailsPageCalculatorAdditionalPackagesConnectedProps) {
  const calculator = useCalculatorContext();
  return (
    <DetailsPageCalculatorAdditionalPackages
      pageType={pageType}
      calculatorTabSelected={calculator.activeTab}
      infoPackageItems={calculator.infoPackageItems}
      literals={literals}
      isSeoModel={isSeoModel}
      modelNameForHeaders={modelNameForHeaders}
    />
  );
}
